import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WorkspaceContext = createContext(null);
export const useWorkspace = () => useContext(WorkspaceContext);

export const WorkspaceProvider = ({ children }) => {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("aps_active_ws") || null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const res = await api.get("/workspaces");
      setWorkspaces(res.data);
      if (res.data.length && !res.data.find((w) => w.id === activeId)) {
        setActiveId(res.data[0].id);
        localStorage.setItem("aps_active_ws", res.data[0].id);
      }
    } finally {
      setLoading(false);
    }
  }, [user, activeId]);

  useEffect(() => {
    if (user) refresh();
  }, [user]); // eslint-disable-line

  const selectWorkspace = (id) => {
    setActiveId(id);
    localStorage.setItem("aps_active_ws", id);
  };

  const active = workspaces.find((w) => w.id === activeId) || null;

  return (
    <WorkspaceContext.Provider
      value={{ workspaces, active, activeId, loading, refresh, selectWorkspace }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
};
